// extracted by mini-css-extract-plugin
export default {"StopButton":"StopButton_StopButton__Pd5k9"};